const Locale = {
	// Australian Dollar
	'en-AU': {
		currency: 'AUD'
	},
	// Canadian Dollar
	'en-CA': {
		currency: 'CAD'
	},
	// British Pounds
	'en-GB': {
		currency: 'GBP'
	},
	// Euro
	'en-IE': {
		currency: 'EUR'
	},
	// New Zealand Dollar
	'en-NZ': {
		currency: 'NZD'
	},
	// US Dollar
	'en-US': {
		currency: 'USD'
	},
	'es-ES': {
		currency: 'EUR'
	},
	// French Canadian Dollar
	'fr-CA': {
		currency: 'USD'
	},
	// French Euro
	'fr-FR': {
		currency: 'EUR'
	},
	// Japanese Yen
	'ja-JP': {
		currency: 'JPY'
	}
};

// options pulled from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
export class CurrencyFormat {
	constructor(locale) {
		this.locale = locale;
		this.options = {
			style: 'currency',
			currencyDisplay: 'narrowSymbol',
			currency: Locale[locale]?.currency || 'USD'
		};
	}

	format(amount, options = {}) {
		const number = Number(amount);
		if (!isNaN(number)) {
			return new Intl.NumberFormat(this.locale, {
				...this.options,
				...options
			}).format(number);
		}

		return amount;
	}
}

export function formatCurrency(value) {
	return new CurrencyFormat().format(value);
}
